module.exports = __webpack_public_path__ + "static/flags/UZ-f6c6425e4e8a51d8dde898dc15d42efe.gif";